'use strict';

const MARK_READ = '@@chatChannels/MARK_READ';
const MARK_READ_SUCCESS = '@@chatChannels/MARK_READ_SUCCESS';
const MARK_READ_ERROR = '@@chatChannels/MARK_READ_ERROR';

/**
 *
 * @param {String} id - the channel ID
 * @param {Number} count - the total read messages
 * @return {ReduxAction}
 */
export function markCommentsRead(id, count) {
  return {
    type: MARK_READ,
    payload: {
      id,
      count,
    },
  };
}
markCommentsRead.TYPE = MARK_READ;

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function markCommentsReadSuccess(id) {
  return {
    type: MARK_READ_SUCCESS,
    payload: {
      id,
    },
  };
}
markCommentsReadSuccess.TYPE = MARK_READ_SUCCESS;

/**
 *
 * @param {String} id
 * @param {Error} err
 * @return {ReduxAction}
 */
export function markCommentsReadError(id, err) {
  return {
    type: MARK_READ_ERROR,
    payload: {
      id,
      err,
    },
  };
}
markCommentsReadError.TYPE = MARK_READ_ERROR;



// WEBPACK FOOTER //
// ./src/js/comments/actions/chatChannels.js